import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, Transition as _Transition, withModifiers as _withModifiers, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-72d9399a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fields" };
const _hoisted_2 = { class: "wrap field" };
const _hoisted_3 = { for: "fullName" };
const _hoisted_4 = ["placeholder", "disabled"];
const _hoisted_5 = { class: "wrap field" };
const _hoisted_6 = { for: "name" };
const _hoisted_7 = ["placeholder", "disabled"];
const _hoisted_8 = { class: "wrap field field__tooltip" };
const _hoisted_9 = { for: "associated-account" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_11 = {
    key: 0,
    style: { "border-left-color": "#999" },
    class: "vs__spinner"
};
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = { class: "wrap field" };
const _hoisted_15 = { for: "access-type" };
const _hoisted_16 = { class: "wrap field" };
const _hoisted_17 = { for: "enrolment" };
const _hoisted_18 = ["placeholder", "disabled"];
const _hoisted_19 = {
    key: 0,
    class: "message_loader"
};
const _hoisted_20 = { class: "wrap field" };
const _hoisted_21 = { for: "store" };
const _hoisted_22 = { class: "wrap field field__tooltip" };
const _hoisted_23 = { for: "phone" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_25 = { class: "fields__phone" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "fields__phone--prefix" }, "+55", -1));
const _hoisted_27 = ["disabled"];
const _hoisted_28 = {
    key: 0,
    class: "fields__phone-error"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = { class: "wrap field" };
const _hoisted_31 = { for: "status" };
const _hoisted_32 = { class: "wrap field fields__coupon-code" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "coupon-code" }, "Cupom do vendedor (opcional)", -1));
const _hoisted_34 = {
    key: 0,
    class: "pin-wrapper"
};
const _hoisted_35 = { class: "wrap pin-container-button" };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
    key: 0,
    class: "wrap pin-container-text"
};
const _hoisted_38 = { class: "pin-text" };
const _hoisted_39 = ["value"];
const _hoisted_40 = ["innerHTML"];
const _hoisted_41 = { class: "container-pin" };
const _hoisted_42 = ["src"];
const _hoisted_43 = ["innerHTML"];
const _hoisted_44 = ["innerHTML"];
const _hoisted_45 = { class: "row inactive-seller-wrapper" };
const _hoisted_46 = { key: 0 };
const _hoisted_47 = { class: "seeler-text-1" };
const _hoisted_48 = {
    key: 1,
    class: "wrap"
};
const _hoisted_49 = { class: "seeler-text-1" };
const _hoisted_50 = { key: 0 };
const _hoisted_51 = { class: "row button-submit-wrapper" };
const _hoisted_52 = { class: "wrap" };
const _hoisted_53 = ["disabled", "onClick"];
import bus from '@/helpers/events/bus';
import i18n from '@/i18n';
import router from '@/router';
import { profileType, status } from '@/utilities/constants';
import { debounce } from 'lodash';
import { computed, onBeforeUnmount, onMounted, reactive, watch } from 'vue';
import vSelect from 'vue-select';
import { useToast } from 'vue-toastification';
import { usePinManagement, useSellerData } from './composables';
// services
import { getVerifyEnrolment, putSeller, setAlternateSeller } from '@/services/oto/sellers';
import store from '@/store';
// components - atoms
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
var ACCESS_TYPE;
(function (ACCESS_TYPE) {
    ACCESS_TYPE[ACCESS_TYPE["SELLER"] = 0] = "SELLER";
    ACCESS_TYPE[ACCESS_TYPE["ADMIN"] = 1] = "ADMIN";
})(ACCESS_TYPE || (ACCESS_TYPE = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'SellerDetail',
    props: {
        sellerId: {}
    },
    setup(__props) {
        const props = __props;
        // libs, helpers
        const isNewSeller = computed(() => isNaN(Number(props.sellerId)));
        const state = reactive({
            storeId: null,
            fields: {
                name: '',
                fullName: '',
                storeId: null,
                enrolment: '',
                enabled: 1,
                status: 'active',
                alternate: null,
                userId: null,
                userEmail: null,
                isAdmin: 0,
                code: '',
                mobileNumber: '',
            },
            mobileNumberErrorMessage: '',
            statusList: [
                { id: 0, name: i18n.global.t('store-management.sellers.inactive') },
                { id: 1, name: i18n.global.t('store-management.sellers.active') },
            ],
            selectedStoreId: '',
            loading: false,
            enrolmentMessage: '',
            isLoadingMessage: false,
            isVisible: false,
            permissionType: false,
            isFormSubmitting: false,
        });
        const accessTypeOptions = computed(() => [
            { id: 0, name: i18n.global.t('store-management.sellers.seller') },
            { id: 1, name: i18n.global.t('store-management.sellers.manager') },
        ]);
        const mobileNumberDigits = computed(() => {
            const { mobileNumber } = state.fields;
            return mobileNumber ? mobileNumber.replace(/\D/g, '') : '';
        });
        // Composables
        const toast = useToast();
        const { sellerDetail, isLoading, alternativeSellers, fetchDetails } = useSellerData();
        const { generatedPin, generateNewPin, copyText, getCustomTextPinButton, clearPinValue } = usePinManagement(isNewSeller);
        //// Migrated computed properties
        // Getters
        const user = computed(() => store?.getters?.user);
        const hasSso = computed(() => store?.getters?.hasSso);
        const getOrderedStores = computed(() => store.getters['sellers/getOrderedStores']);
        const customerDistribution = computed(() => store.getters['customerDistribution']);
        const getEmailLoadingStatus = computed(() => store.getters['sellers/getEmailLoadingStatus']);
        const getAvailableEmails = computed(() => store.getters['sellers/getAvailableEmails']);
        // Actions
        const getAvailableEmailList = (email) => store.dispatch('sellers/getAvailableEmailList', email);
        const resetEmailList = () => store.dispatch('sellers/resetEmailList');
        const getStoresList = () => store.dispatch('sellers/getStoresList');
        // Watchers
        watch(() => props.sellerId, newValue => {
            if (!newValue)
                return;
            openSellerModal(newValue);
        });
        watch(() => state.isVisible, newValue => {
            // Handle cleanup when modal closes
            if (!newValue) {
                resetEmailList();
                resetForm();
                clearPinValue();
                router.push({ name: 'store-management-sellers' });
            }
        });
        watch(() => sellerDetail.value, newValue => {
            if (isNewSeller.value)
                return resetForm();
            populateFormFields(newValue);
        });
        watch(() => state.fields.isAdmin, newValue => {
            const isAdmin = 1;
            if (Number(newValue) === isAdmin) {
                state.fields.storeId = null;
                state.selectedStoreId = null;
            }
        });
        //// Methods
        // Pin Management
        function handlePin() {
            const storeId = state.fields.isAdmin === 1 ? '-1' : state.fields.storeId;
            generateNewPin(Number(props.sellerId), storeId);
        }
        // Seller Form
        function getDefaultFields() {
            return {
                name: '',
                fullName: '',
                storeId: null,
                enrolment: '',
                enabled: 1,
                status: status.active,
                alternate: null,
                userId: null,
                userEmail: null,
                isAdmin: 0,
                code: null,
                mobileNumber: '',
            };
        }
        function resetForm() {
            Object.assign(state.fields, getDefaultFields());
            state.selectedStoreId = null;
            state.mobileNumberErrorMessage = '';
        }
        function populateFormFields(sellerData) {
            state.fields.name = sellerData.name;
            state.fields.fullName = sellerData.fullName;
            state.fields.storeId = sellerData.store.id;
            state.fields.enrolment = sellerData.enrolment;
            state.fields.enabled = sellerData.enabled;
            state.fields.status = sellerData.status;
            state.fields.alternate = sellerData.alternate;
            state.fields.userId = sellerData.userId || null;
            state.fields.userEmail = sellerData.userEmail;
            state.fields.isAdmin = sellerData.admin ? 1 : 0;
            state.fields.code = sellerData.code;
            state.fields.mobileNumber = sellerData.mobileNumber;
            state.selectedStoreId = state.fields.storeId;
            if (state.fields.mobileNumber) {
                validatePhoneNumber();
            }
        }
        function onChangeStatus() {
            state.fields.status = state.fields.enabled === 1 ? status.active : status.inactive;
        }
        function setUserEmail(userInfo) {
            // refresh user on edition mode - get email by selected user
            const user = getAvailableEmails.value.find(el => el.userId === userInfo.userId);
            state.fields.userEmail = user?.email;
        }
        function isSellerWithNewStore() {
            return !isNewSeller.value && state.fields.storeId !== sellerDetail.value.store.id && state.fields.isAdmin !== 1;
        }
        function setEmailSearch(email) {
            if (!email)
                return;
            triggerDebounce(email);
        }
        const triggerDebounce = debounce(function (email) {
            getAvailableEmailList(email);
        }, 800);
        function storeChanged(store) {
            state.selectedStoreId = store.id;
            state.fields.storeId = store.id;
            if (isSellerWithNewStore()) {
                setTimeout(() => {
                    bus.$emit('openChangeStoreModal');
                }, 100);
            }
        }
        // return message according to response from api
        function enrolmentMessagesOptions(enrolmentMsg) {
            const messages = {
                'seller-found': i18n.global.t('store-management.sellers.enrolment-messages.belongs-to-other-seller'),
                'enrolment-found': i18n.global.t('store-management.sellers.enrolment-messages.no-associated-seller'),
                'enrolment-not-found': i18n.global.t('store-management.sellers.enrolment-messages.not-found'),
            };
            state.enrolmentMessage = enrolmentMsg ? messages[enrolmentMsg] : '';
        }
        // function to validate enrolment
        function fetchVerifyEnrolment() {
            state.isLoadingMessage = true;
            if (!state.fields.enrolment) {
                state.enrolmentMessage = '';
                state.isLoadingMessage = false;
                return;
            }
            getVerifyEnrolment({ enrolment: state.fields.enrolment })
                .then(({ data }) => {
                enrolmentMessagesOptions(data?.data?.code);
            })
                .finally(() => {
                state.isLoadingMessage = false;
            });
        }
        function resolveStoreName(id, name) {
            if (id)
                return `${name} - ${id}`;
        }
        function responsePutSeller({ errors, success }) {
            if (!success) {
                const errorName = errors.code.replaceAll(' ', '-');
                toast.error(i18n.global.t(`errors.err-${errorName}`));
            }
            else {
                closeModal();
                const managerStr = i18n.global.t('store-management.sellers.manager');
                const sellerStr = i18n.global.t('store-management.sellers.seller');
                const message = isNewSeller.value
                    ? i18n.global.t('store-management.sellers.seller-registered', {
                        isManager: state.fields.isAdmin ? managerStr : sellerStr,
                    })
                    : i18n.global.t('store-management.sellers.seller-updated');
                setTimeout(() => {
                    toast.success(message);
                    bus.$emit('sellers-reload-list');
                }, 70);
            }
        }
        function validatePhoneNumber() {
            const digits = mobileNumberDigits.value;
            if (digits.length && !(digits.length === 10 || digits.length === 11)) {
                state.mobileNumberErrorMessage = i18n.global.t('store-management.sellers.invalid-phone-number');
            }
            else {
                state.mobileNumberErrorMessage = '';
            }
        }
        function checkRequiredFields() {
            if (state.fields.isAdmin !== ACCESS_TYPE.SELLER && state.fields.isAdmin !== ACCESS_TYPE.ADMIN) {
                state.fields.isAdmin = ACCESS_TYPE.SELLER;
            }
            const isAdmin = state.fields.isAdmin === ACCESS_TYPE.ADMIN;
            const isSeller = state.fields.isAdmin === ACCESS_TYPE.SELLER;
            const alwaysOptionalFields = ['code', 'mobileNumber', 'alternate', 'userEmail'];
            const optionalFields = isAdmin ? [...alwaysOptionalFields, 'storeId'] : alwaysOptionalFields;
            if (isSeller && !state.fields.storeId) {
                return true;
            }
            const hasEmptyRequired = Object.entries(state.fields).some(([key, value]) => {
                if (optionalFields.includes(key)) {
                    return false;
                }
                const isEmpty = value === '' || value === null || value === undefined;
                return isEmpty;
            });
            return hasEmptyRequired;
        }
        function commitChange() {
            state.isFormSubmitting = true;
            // bypass empty storeId from validation case admin is active
            if (state.fields.isAdmin === 1) {
                delete state.fields.storeId;
                delete state.fields.alternate;
            }
            // check if required fields are empty
            if (checkRequiredFields()) {
                toast.error(i18n.global.t('store-management.sellers.fill-fields'), {
                    timeout: 5000,
                });
                state.isFormSubmitting = false;
                return;
            }
            // validate phone number
            if (state.fields.mobileNumber && state.mobileNumberErrorMessage) {
                toast.error(state.mobileNumberErrorMessage, {
                    timeout: 5000,
                });
                state.isFormSubmitting = false;
                return;
            }
            if (!isNewSeller.value && state.fields.enabled === 0 && state.fields.alternate !== null && !state.fields.isAdmin) {
                setAlternateSeller(Number(props.sellerId), state.fields.alternate);
            }
            // If editing an existing seller and their mobile number is being cleared,
            // set 'disableNumber' to true so the backend disables the number.
            const shouldDisableNumber = !isNewSeller.value && sellerDetail.value.mobileNumber && state.fields.mobileNumber === '';
            // new seller or edit seller
            putSeller({
                ...state.fields,
                mobileNumber: mobileNumberDigits.value,
                ...(generatedPin.value !== '' && { pin: generatedPin.value }),
                ...(!isNewSeller.value && { id: Number(props.sellerId) }),
                ...(shouldDisableNumber && { disableNumber: true }),
                action: state.fields.status,
                alternate: state.fields.alternate,
            })
                .then(response => responsePutSeller(response))
                .finally(() => {
                state.isFormSubmitting = false;
            });
        }
        function openModal() {
            state.isVisible = true;
        }
        function closeModal() {
            state.isVisible = false;
        }
        function openSellerModal(sellerId) {
            if (!sellerId)
                return;
            // sellerId can be a dynamic id or 'create'
            if (sellerId === 'create' || Number(sellerId)) {
                fetchDetails(sellerId);
                openModal();
            }
        }
        function hasPermissionAdmin() {
            state.permissionType =
                user.value?.profile !==
                    (profileType.executives ||
                        profileType.operations ||
                        profileType.products ||
                        profileType.stores ||
                        profileType.onlyOto);
        }
        onMounted(() => {
            hasPermissionAdmin();
            getStoresList();
            closeModal();
            bus.$on('restore-store', () => {
                state.fields.storeId = sellerDetail.value.store.id === '-1' ? '' : sellerDetail.value.store.id;
            });
            openSellerModal(props.sellerId);
        });
        onBeforeUnmount(() => {
            bus.$off(['restore-store']);
        });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_dialog = _resolveComponent("el-dialog");
            const _directive_mask = _resolveDirective("mask");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: state.isVisible,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((state.isVisible) = $event)),
                id: "seller-detail",
                width: "680"
            }, _createSlots({
                default: _withCtx(() => [
                    (!_unref(isLoading))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('store-management.sellers.name')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "fullName",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.fields.fullName) = $event)),
                                        placeholder: _ctx.$t('store-management.sellers.seller-fullname'),
                                        "data-cy": "form-seller-fullname",
                                        disabled: hasSso.value
                                    }, null, 8, _hoisted_4), [
                                        [_vModelText, state.fields.fullName]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('store-management.sellers.name-label')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "name",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((state.fields.name) = $event)),
                                        placeholder: _ctx.$t('store-management.sellers.name-placeholder'),
                                        "data-cy": "form-seller-name",
                                        disabled: hasSso.value
                                    }, null, 8, _hoisted_7), [
                                        [_vModelText, state.fields.name]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("label", _hoisted_9, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.associated-account')) + " ", 1),
                                        _createVNode(_component_el_tooltip, {
                                            content: _ctx.$t('store-management.sellers.associated-account-tooltip-content'),
                                            placement: "top",
                                            "popper-class": "seller-detail__tooltip"
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_10
                                            ]),
                                            _: 1
                                        }, 8, ["content"])
                                    ]),
                                    _createVNode(_unref(vSelect), {
                                        id: "associated-account",
                                        modelValue: state.fields.userId,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((state.fields.userId) = $event)),
                                        label: "email",
                                        clearable: false,
                                        "input-id": `stores-account-email`,
                                        "data-cy": "form-seller-email",
                                        class: "sellers-email-list w-100",
                                        reduce: email => email.userId,
                                        options: getAvailableEmails.value,
                                        placeholder: _ctx.$t('store-management.sellers.type-context-account'),
                                        loading: getEmailLoadingStatus.value,
                                        disabled: hasSso.value,
                                        onSearch: setEmailSearch,
                                        "onOption:selected": setUserEmail
                                    }, {
                                        "open-indicator": _withCtx(({ attributes }) => [
                                            _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                        ]),
                                        spinner: _withCtx(({ loading }) => [
                                            loading
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                                                : _createCommentVNode("", true)
                                        ]),
                                        "selected-option": _withCtx(({ userId }) => [
                                            (getAvailableEmails.value[0] && !getAvailableEmails.value.find(el => el.userId === userId))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(getAvailableEmails.value[0].email), 1))
                                                : (state.fields.userEmail)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(state.fields.userEmail), 1))
                                                    : _createCommentVNode("", true)
                                        ]),
                                        "no-options": _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.no-results')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "reduce", "options", "placeholder", "loading", "disabled"])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('store-management.sellers.access-type')), 1),
                                    _createVNode(_unref(vSelect), {
                                        id: "access-type",
                                        modelValue: state.fields.isAdmin,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((state.fields.isAdmin) = $event)),
                                        label: "name",
                                        clearable: false,
                                        "input-id": `stores-access-type`,
                                        class: "w-100",
                                        reduce: admin => admin.id,
                                        options: accessTypeOptions.value,
                                        placeholder: _ctx.$t('store-management.sellers.placeholder'),
                                        disabled: !state.permissionType || hasSso.value
                                    }, {
                                        "open-indicator": _withCtx(({ attributes }) => [
                                            _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                        ]),
                                        "no-options": _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.no-results')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "reduce", "options", "placeholder", "disabled"])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('store-management.sellers.enrolment')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "enrolment",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((state.fields.enrolment) = $event)),
                                        placeholder: _ctx.$t('store-management.sellers.enrolment'),
                                        disabled: hasSso.value,
                                        "data-cy": "form-seller-enrolment",
                                        onBlur: fetchVerifyEnrolment
                                    }, null, 40, _hoisted_18), [
                                        [_vModelText, state.fields.enrolment]
                                    ]),
                                    (state.isLoadingMessage)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createVNode(BaseLoader, { height: '25' })
                                        ]))
                                        : _createCommentVNode("", true),
                                    _withDirectives(_createElementVNode("span", { class: "message" }, _toDisplayString(state.enrolmentMessage), 513), [
                                        [_vShow, state.enrolmentMessage]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('store-management.sellers.store')), 1),
                                    (_openBlock(), _createBlock(_unref(vSelect), {
                                        id: "store",
                                        key: state.selectedStoreId,
                                        modelValue: state.fields.storeId,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((state.fields.storeId) = $event)),
                                        value: state.selectedStoreId,
                                        label: "name",
                                        clearable: false,
                                        "input-id": `stores-select`,
                                        "data-cy": "form-seller-stores-select",
                                        class: "w-100",
                                        options: getOrderedStores.value,
                                        reduce: store => store.id,
                                        placeholder: _ctx.$t('store-management.sellers.placeholder'),
                                        disabled: Boolean(state.fields.isAdmin) || hasSso.value,
                                        "onOption:selected": storeChanged
                                    }, {
                                        option: _withCtx(({ name, id }) => [
                                            _createElementVNode("span", null, _toDisplayString(resolveStoreName(id, name)), 1)
                                        ]),
                                        "selected-option": _withCtx(({ name, id }) => [
                                            _createElementVNode("span", null, _toDisplayString(resolveStoreName(id, name)), 1)
                                        ]),
                                        "open-indicator": _withCtx(({ attributes }) => [
                                            _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                        ]),
                                        "no-options": _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.no-results')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "value", "options", "reduce", "placeholder", "disabled"]))
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("label", _hoisted_23, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.mobile-number')) + " ", 1),
                                        _createVNode(_component_el_tooltip, {
                                            content: _ctx.$t('store-management.sellers.mobile-number-tooltip-content'),
                                            placement: "top",
                                            "popper-class": "seller-detail__tooltip"
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_24
                                            ]),
                                            _: 1
                                        }, 8, ["content"])
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                        _hoisted_26,
                                        _withDirectives(_createElementVNode("input", {
                                            id: "phone",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((state.fields.mobileNumber) = $event)),
                                            class: _normalizeClass({ 'input-error': state.mobileNumberErrorMessage }),
                                            placeholder: '99 999999999',
                                            disabled: hasSso.value,
                                            "data-cy": "form-seller-phone",
                                            onBlur: validatePhoneNumber
                                        }, null, 42, _hoisted_27), [
                                            [_vModelText, state.fields.mobileNumber],
                                            [_directive_mask, ['## #########', '## ########']]
                                        ])
                                    ]),
                                    _createVNode(_Transition, { name: "error-fade" }, {
                                        default: _withCtx(() => [
                                            (state.mobileNumberErrorMessage)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                    _createElementVNode("img", {
                                                        src: require('@/assets/svgs/red-alert-icon.svg')
                                                    }, null, 8, _hoisted_29),
                                                    _createElementVNode("small", null, _toDisplayString(state.mobileNumberErrorMessage), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('store-management.sellers.status')), 1),
                                    _createVNode(_unref(vSelect), {
                                        id: "status",
                                        modelValue: state.fields.enabled,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((state.fields.enabled) = $event)),
                                        label: "name",
                                        clearable: false,
                                        class: "w-100",
                                        "data-cy": "form-select-status",
                                        reduce: enabled => enabled.id,
                                        options: state.statusList,
                                        placeholder: _ctx.$t('store-management.sellers.placeholder'),
                                        "onOption:selected": onChangeStatus
                                    }, {
                                        "open-indicator": _withCtx(({ attributes }) => [
                                            _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                        ]),
                                        "no-options": _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.no-results')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "reduce", "options", "placeholder"])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((state.fields.code) = $event)),
                                        id: "coupon-code",
                                        placeholder: "Digite o código ou insira o link"
                                    }, null, 512), [
                                        [_vModelText, state.fields.code]
                                    ])
                                ])
                            ]),
                            (!hasSso.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("button", {
                                            class: "btn btn-pin",
                                            "data-cy": "btn-pin",
                                            onClick: _withModifiers(handlePin, ["prevent"])
                                        }, _toDisplayString(_unref(getCustomTextPinButton)()), 9, _hoisted_36)
                                    ]),
                                    (_unref(generatedPin))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                            _createElementVNode("p", _hoisted_38, [
                                                _createTextVNode(_toDisplayString(_unref(generatedPin)), 1),
                                                _createElementVNode("a", {
                                                    href: "#",
                                                    onClick: _cache[9] || (_cache[9] =
                                                        //@ts-ignore
                                                        (...args) => (_unref(copyText) && _unref(copyText)(...args)))
                                                }, _toDisplayString(_ctx.$t('store-management.sellers.copy')), 1)
                                            ]),
                                            _createElementVNode("input", {
                                                ref: "inputPin",
                                                type: "hidden",
                                                value: _unref(generatedPin)
                                            }, null, 8, _hoisted_39),
                                            (isNewSeller.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("p", {
                                                        innerHTML: _ctx.$t('store-management.sellers.store-the-number-message')
                                                    }, null, 8, _hoisted_40),
                                                    _createElementVNode("div", _hoisted_41, [
                                                        _createElementVNode("img", {
                                                            src: require(`@/assets/img/icons/png/warning.png`)
                                                        }, null, 8, _hoisted_42),
                                                        _createElementVNode("p", {
                                                            innerHTML: _ctx.$t('store-management.sellers.store-the-number-message-create-seller')
                                                        }, null, 8, _hoisted_43)
                                                    ])
                                                ], 64))
                                                : (_openBlock(), _createElementBlock("p", {
                                                    key: 1,
                                                    innerHTML: _ctx.$t('store-management.sellers.reset-pin-message')
                                                }, null, 8, _hoisted_44))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("div", _hoisted_45, [
                                (customerDistribution.value && state.fields.status === _unref(status).inactive)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _createElementVNode("p", _hoisted_47, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.seller')) + " ", 1),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(state.fields.status)
                                            }, _toDisplayString(_ctx.$t(`store-management.sellers.${state.fields.status}`)), 3)
                                        ]),
                                        _createElementVNode("p", {
                                            class: _normalizeClass(`seeler-text-${state.fields.status}-leveling`)
                                        }, _toDisplayString(_ctx.$t(`store-management.sellers.${state.fields.status}-seller-leveling`)), 3)
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", _hoisted_49, [
                                                _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.seller')) + " ", 1),
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(state.fields.status)
                                                }, _toDisplayString(_ctx.$t(`store-management.sellers.${state.fields.status}`)), 3)
                                            ]),
                                            _createElementVNode("p", {
                                                class: _normalizeClass(`seeler-text-${state.fields.status}`)
                                            }, _toDisplayString(_ctx.$t(`store-management.sellers.${state.fields.status}-seller`)), 3)
                                        ]),
                                        (state.fields.status === _unref(status).inactive)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('store-management.sellers.alternate')), 1),
                                                _createVNode(_unref(vSelect), {
                                                    modelValue: state.fields.alternate,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((state.fields.alternate) = $event)),
                                                    label: "name",
                                                    clearable: false,
                                                    "input-id": `sellers-select`,
                                                    class: "responsible",
                                                    options: [{ id: null, name: _ctx.$t('store-management.sellers.random') }, ..._unref(alternativeSellers)],
                                                    reduce: store => store.id,
                                                    placeholder: _ctx.$t('store-management.sellers.placeholder')
                                                }, {
                                                    "open-indicator": _withCtx(({ attributes }) => [
                                                        _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                                    ]),
                                                    "no-options": _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('store-management.sellers.no-results')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["modelValue", "options", "reduce", "placeholder"])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                            ], 512), [
                                [_vShow, state.fields.status && state.fields.status !== _unref(status).active && !state.fields.isAdmin]
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("button", {
                                        class: "btn",
                                        "data-cy": "btn-save-seller",
                                        disabled: checkRequiredFields() || state.isFormSubmitting,
                                        onClick: _withModifiers(commitChange, ["prevent"])
                                    }, _toDisplayString(!state.isFormSubmitting ? _ctx.$t('store-management.sellers.save') : _ctx.$t('loading-dots')), 9, _hoisted_53)
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    _withDirectives(_createVNode(BaseLoader, null, null, 512), [
                        [_vShow, _unref(isLoading)]
                    ])
                ]),
                _: 2
            }, [
                (!_unref(isLoading))
                    ? {
                        name: "header",
                        fn: _withCtx(() => [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t(`store-management.sellers.${isNewSeller.value ? 'new-seller' : 'edit-seller'}`)), 1)
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032, ["modelValue"]));
        };
    }
});
